// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/FiscalPeriod.yaml
// Generated: 2026-05-31T11:28:48.312Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateFiscalPeriod, UpdateFiscalPeriod, FiscalPeriod } from '@/types/finance/FiscalPeriod';

/**
 * FiscalPeriod Service
 * CRUD operations for FiscalPeriod via the ABP API.
 */
export const fiscalPeriodService = new EntityService<FiscalPeriod, CreateFiscalPeriod, UpdateFiscalPeriod>(
  '/api/finance/fiscalperiod',
  'FiscalPeriod',
);
